<template>
  <div class="prodcuts__list_view" v-if="products.length">
    <!-- products -->
    <div class="product min-w-full flex h-64 rounded-lg overflow-hidden shadow-md mt-8" v-for="(product, index) in products" :key="index">
      <div class="product__image w-1/3 mr-5">
        <img class="ml-auto mr-auto w-full h-full object-cover" :src="product.images_image_path || require('@/assets/images/products/pr_default.jpg')" />
      </div>
      <div class="product__details w-2/3 relative">
        <div class="product__ribbon absolute w-32 h-32 right-0" v-if="verifiedSellersRole.includes(product.parent_users_roleId)">
          <div class="ribbon absolute text-white text-center">Verified Seller</div>
        </div>

        <!-- product title -->
        <div class="product__title mt-5">
          <router-link
            :to="{
              name: 'marketlist-view-product',
              params: {
                id: product.products_id
              }
            }"
          >
            <h2 class="mb-2 font-semibold">{{ product.products_product_name }}</h2>
          </router-link>
        </div>

        <!-- product seller -->
        <div class="product__seller">
          <router-link
            :to="{
              name: 'marketlist-view-sellerProducts',
              params: {
                id: product.parent_users_id
              }
            }"
          >
            <p class="mb-2 text-black font-medium">Sold By {{ product.parent_users_business_name ? product.parent_users_business_name : product.parent_users_username }}</p>
          </router-link>
        </div>
        <div class="flex justify-between mt-5">
          <div class="product__category">
            <p class="font-medium">{{ product.category_category_name }}</p>
          </div>
          <div class="product__price mr-5">
            <h4 class="font-bold">$ {{ product.products_sales_price | currencyFilter }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mx-auto text-center text-xl font-bold my-5" v-else>No Product Found</div>
</template>

<script>
import { weightMixins } from '@/utils/weightType'
import { paymentMixins } from '@/utils/paymentTypes'
import { ADMIN, GROWER, PROCESSOR, RETAILER } from '@/utils/roles.js'

export default {
  name: 'ProductListView',

  props: {
    products: Array
  },

  data() {
    return {
      verifiedSellersRole: [ADMIN, GROWER, PROCESSOR, RETAILER]
    }
  },

  mixins: [weightMixins, paymentMixins],

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  }
}
</script>

<style lang="scss">
.prodcuts__list_view {
  .product__details {
    .ribbon {
      transform: rotate(45deg);
      top: 30px;
      width: 140px;
      background: #008000;
    }

    h2:hover,
    p:hover {
      color: #008000 !important;
    }
  }
}
</style>